import { createReducer, on } from '@ngrx/store';
import { setCoinAction } from './coin.actions';
import { isCountryBR } from 'src/app/common/util/util';

export const initialState = isCountryBR() ? 'BRL' : 'USD';

export const coinReducer = createReducer(
  initialState,
  on(setCoinAction, (state, { coin }) => coin)
);